import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { getSystemInfo } from "../utils/getSystemInfo";
import { getPath } from "../utils/tools";
import TracertCore from "./tracert";
import { reStoreUserPath } from "../funnel";
import Log from "../log/index";
import autoClickPlugin from "../plugins/auto-click";
import autoExpoPlugin from "../plugins/auto-expo";
import fullfillRefspmPlugin from "../plugins/fullfill-ref";
import timeOnPagePlug from "../plugins/time-on-page";
import Spm from "../spm/index";
import { Tracker } from "./tracker";
import { getEnv, getTimeZone } from "../utils";
var Tracert = new TracertCore();

// 新加坡和美国日志服务器
var imdapServers = ['https://imdap-sea.alipay.com/loggw/dwcookieLogGet.do', 'https://imdap.alipay.com/loggw/dwcookieLogGet.do'];

/**
 * 初始化spm上报，项目初始化时初始化一次
 * @param config
 * @param TracertTa 外面引入脚本
 */
function initiTracker(_x) {
  return _initiTracker.apply(this, arguments);
}
function _initiTracker() {
  _initiTracker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    var _window, _spmConfig$bizType;
    var spmConfig, _params$funnelAuto, funnelAuto, _params$userPathAuto, userPathAuto, _params$autoExpo, autoExpo, _params$autoClick, autoClick, bizType, appId, productId, _params$batchCount, batchCount, _params$imdapServerIn, imdapServerIndex, _params$server, server, _params$mdata, mdata, _params$env, env, _params$plugins, plugins, _params$userId, userId, _params$deviceId, deviceId, _params$ready, ready, _params$isReport, isReport, _params$version, version, chInfo, _params$expoOnce, expoOnce, _params$platform, platform, imdapServer, _env, init, _params;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          init = function _init(_env) {
            try {
              return new Promise(function (resolve) {
                var path = getPath();
                var promiseAll = [getEnv(), getSystemInfo()];
                Promise.all(promiseAll).then(function (res) {
                  var env = res[0] || '';
                  var systemInfo = res[1] || {};
                  resolve({
                    env: env,
                    systemInfo: systemInfo,
                    url: path,
                    userId: userId,
                    deviceId: deviceId
                  });
                });
              });
            } catch (e) {
              console.error(e);
              return Promise.resolve({
                env: getEnv() || 'PROD',
                url: getPath(),
                networkType: '',
                systemInfo: null,
                userId: userId,
                deviceId: deviceId
              });
            }
          };
          spmConfig = params.spmConfig, _params$funnelAuto = params.funnelAuto, funnelAuto = _params$funnelAuto === void 0 ? true : _params$funnelAuto, _params$userPathAuto = params.userPathAuto, userPathAuto = _params$userPathAuto === void 0 ? true : _params$userPathAuto, _params$autoExpo = params.autoExpo, autoExpo = _params$autoExpo === void 0 ? true : _params$autoExpo, _params$autoClick = params.autoClick, autoClick = _params$autoClick === void 0 ? true : _params$autoClick, bizType = params.bizType, appId = params.appId, productId = params.productId, _params$batchCount = params.batchCount, batchCount = _params$batchCount === void 0 ? 5 : _params$batchCount, _params$imdapServerIn = params.imdapServerIndex, imdapServerIndex = _params$imdapServerIn === void 0 ? 0 : _params$imdapServerIn, _params$server = params.server, server = _params$server === void 0 ? '' : _params$server, _params$mdata = params.mdata, mdata = _params$mdata === void 0 ? {} : _params$mdata, _params$env = params.env, env = _params$env === void 0 ? '' : _params$env, _params$plugins = params.plugins, plugins = _params$plugins === void 0 ? [] : _params$plugins, _params$userId = params.userId, userId = _params$userId === void 0 ? '' : _params$userId, _params$deviceId = params.deviceId, deviceId = _params$deviceId === void 0 ? '' : _params$deviceId, _params$ready = params.ready, ready = _params$ready === void 0 ? false : _params$ready, _params$isReport = params.isReport, isReport = _params$isReport === void 0 ? true : _params$isReport, _params$version = params.version, version = _params$version === void 0 ? 'unknown' : _params$version, chInfo = params.chInfo, _params$expoOnce = params.expoOnce, expoOnce = _params$expoOnce === void 0 ? true : _params$expoOnce, _params$platform = params.platform, platform = _params$platform === void 0 ? '' : _params$platform;
          if (!(!(spmConfig !== null && spmConfig !== void 0 && spmConfig.bizType) && !bizType)) {
            _context.next = 4;
            break;
          }
          throw new Error('bizType is empty');
        case 4:
          // 应用id检查
          if (!appId || typeof appId !== 'string') {
            console.warn('invalid appId');
          }
          if (productId) {
            _context.next = 7;
            break;
          }
          throw Error('productId is empty, please check .env file');
        case 7:
          // 优先取外部传入的server，默认新加坡服务器
          imdapServer = server || imdapServers[imdapServerIndex]; // 实例化tracert
          Tracert.set(_objectSpread(_objectSpread({}, ((_window = window) === null || _window === void 0 ? void 0 : _window.autoReportConfig) || {}), {}, {
            bizType: (_spmConfig$bizType = spmConfig === null || spmConfig === void 0 ? void 0 : spmConfig.bizType) !== null && _spmConfig$bizType !== void 0 ? _spmConfig$bizType : bizType,
            server: imdapServer,
            appId: appId,
            productId: productId || appId,
            env: env || getEnv(),
            ready: false,
            logVersion: productId ? '4' : '3',
            packageVersion: "@alipay/intl-tracker-0.0.9001657688-dev.1" || '',
            switch: isReport,
            batchCount: batchCount,
            expoOnce: expoOnce,
            platform: platform,
            mdata: _objectSpread({
              // 通用的数据，可不传，传了所有的埋点均会带该额外参数
              idengine_groupId: appId,
              idengine_chinfo: chInfo || '',
              idengine_version: version || '',
              idengine_timezone: getTimeZone()
            }, mdata),
            chInfo: chInfo
          }));

          // 恢复用户路径
          reStoreUserPath(appId);
          Tracker.set({
            spmConfig: spmConfig,
            Tracert: Tracert,
            funnelAuto: funnelAuto,
            userPathAuto: userPathAuto
          });

          // cabin不加载插件
          if (platform !== 'cabin') {
            plugins.push(timeOnPagePlug);
            plugins.push(fullfillRefspmPlugin);
            if (autoClick) {
              plugins.push(autoClickPlugin);
            }
            if (autoExpo) {
              plugins.push(autoExpoPlugin);
              Tracert.set({
                autoExpo: true
              });
            }
          }
          Tracert.loadPlugins(plugins);

          // 没有获取到也上报
          setTimeout(function () {
            Tracert.set({
              ready: true
            });
          }, 1500);
          _env = env;
          _context.next = 17;
          return init(_env);
        case 17:
          _params = _context.sent;
          // 不能覆盖默认值
          if (_params.deviceId) {
            Tracert.set({
              deviceId: _params.deviceId
            });
          }
          if (_params.systemInfo) {
            Tracert.set({
              systemInfo: _params.systemInfo
            });
          }
          if (_params.userId) {
            Tracert.set({
              userId: _params.userId
            });
          }

          // ready 属性 set 为 true 一定是在所有数据初始化后，即 ready: true 始终在代码末尾
          Tracert.set({
            env: _env || _params.env || 'PROD',
            networkType: _params.networkType,
            path: _params.path
          });

          // 如果初始化时明确ready为false，何时ready由外部控制
          if (!ready) {
            Tracert.set({
              ready: true
            });
          }
          Spm.set({
            reportor: {
              loadSpm: Tracker === null || Tracker === void 0 ? void 0 : Tracker.loadSpm,
              spmExpo: Tracker === null || Tracker === void 0 ? void 0 : Tracker.spmExpo,
              spmClick: Tracker === null || Tracker === void 0 ? void 0 : Tracker.spmClick
            }
          });
          Log.set({
            reportor: {
              reportLog: Tracker === null || Tracker === void 0 ? void 0 : Tracker.reportLog,
              reportRPC: Tracker === null || Tracker === void 0 ? void 0 : Tracker.reportRPC,
              reportFunnel: Tracker === null || Tracker === void 0 ? void 0 : Tracker.reportFunnel
            }
          });
          return _context.abrupt("return", Tracert.ready);
        case 26:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _initiTracker.apply(this, arguments);
}
export { initiTracker, Tracert, Tracker };